module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _c('b', [_vm._v("James Farrer")]), _vm._v(" is professor of sociology and global studies at Sophia University, Tokyo, and author of "), _c('i', [_vm._v("Opening Up: Youth Sex Culture and Market Reform in Shanghai")]), _vm._v(", also published by the University of Chicago Press. "), _c('b', [_vm._v("Andrew David Field")]), _vm._v(" is the author of "), _c('i', [_vm._v("Shanghai’s Dancing World: Cabaret Culture and Urban Politics, 1919–1954")]), _vm._v(" and "), _c('i', [_vm._v("Mu Shiying: China’s Lost Modernist")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2015 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. Published 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("24 23 22 21 20 19 18 17 16 15    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-26274-1 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-26288-8 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-26291-8 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": 10.7208/chicago/9780226262918.001.0001")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Farrer, James (James C.), author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Shanghai nightscapes : a nocturnal biography of a global city / James Farrer and Andrew David Field.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-26274-1 (cloth : alkaline paper)—"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-26288-8 (paperback : alkaline paper)—"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-26291-8 (e-book) 1. Nightlife—China—Shanghai. 2. Shanghai (China)—Social life and customs—20th century. I. Field, Andrew David, author. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DS")]), _vm._v("796."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("S")]), _vm._v("25"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("F")]), _vm._v("37 2015")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("951'.13205—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cipl"
  }, [_vm._v("2014043024")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("♾ This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48–1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942c43ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-farrer-0004.vue
// module id = 63
// module chunks = 0